export default "__VITE_PUBLIC_ASSET__8ac099df__"